import { useAuthStore } from "@/store";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SignupForm } from "../../components/forms";
import { supabase } from "../../lib/supabase";

export function SignupPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const { initialized, user, initializeAuth, profile } = useAuthStore();

  // Enhanced session validation to ensure complete initialization
  const validateSession = async () => {
    try {
      setIsLoading(true);

      // First check for an existing session with Supabase directly
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (session) {
        // Explicitly initialize auth store to ensure all user data is loaded
        await initializeAuth();

        // Check if user needs onboarding by checking profile
        const { data: userProfile } = await supabase
          .from("profiles")
          .select("*")
          .eq("id", session.user.id)
          .single();

        // CRITICAL: Initialize the app immediately after we have the profile
        if (userProfile) {
          await initializeAuth();
        }

        const needsOnboarding = !userProfile?.onboarding_completed;

        if (needsOnboarding) {
          navigate("/auth/onboarding", { replace: true });
        } else {
          navigate("/chat/new", { replace: true });
        }
      } else {
        // No session, show signup form
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  // Check session on component mount
  useEffect(() => {
    validateSession();
  }, []);

  // Also redirect if auth state changes
  useEffect(() => {
    if (initialized && user) {
      // Check if user needs onboarding
      const needsOnboarding = !profile?.onboarding_completed;

      if (needsOnboarding) {
        navigate("/auth/onboarding", { replace: true });
      } else {
        navigate("/chat/new", { replace: true });
      }
    } else if (initialized && !user) {
      // Auth is initialized but no user - show signup form
      setIsLoading(false);
    }
  }, [initialized, user, navigate, profile]);

  return (
    <>
      <SignupForm />
    </>
  );
}

export default SignupPage;
